import { render } from "./memberRegistration.vue?vue&type=template&id=1cb3ba5e"
import script from "./memberRegistration.vue?vue&type=script&lang=js"
export * from "./memberRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/twiga_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__